export default {"src":"/_next/static/media/whatsapp.0c8d49c4.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};